import { frontMatterMarkdownItPlugin } from '@bangle.dev/markdown-front-matter';

export const markdownItPlugins = [frontMatterMarkdownItPlugin];
